import * as serviceWorker from "./serviceWorker";
import ReactDOM from "react-dom";
import App from "./App";
import BlogPage from "./pages/BlogPage";
import {LanguageProvider} from "./contexts/LanguageContext";
import "./index.css";
import "./assets/fonts/Montserrat-Regular.ttf";
import "./assets/fonts/Agustina.woff";

const path = window.location.pathname;
const isBlogPage = path.includes("blogs");

ReactDOM.render(
  <LanguageProvider>{isBlogPage ? <BlogPage /> : <App />}</LanguageProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
